import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './solarized_bootstrap.css';

import {
  getGameInfoFromURL,
  generateLink,
  redirectTo,
  getAdditionalParamsFromURL
} from './Utils';

import { fetchGames, setLaunchError } from './actions/actions.js'; // , fetchOgaInformation} from "./actions/actions.js"

import { Provider } from 'react-redux';

import { unregister } from './registerServiceWorker';
import configureStore from './store/configure-store';

const launchGameFromUrl = getGameInfoFromURL();
const additionalUrlParams = getAdditionalParamsFromURL();

const store = configureStore();
store.dispatch(fetchGames()).then(() => {
  if (launchGameFromUrl) {
    let gameList = store.getState().environment_information.get('games');
    let gameIndex = gameList.findIndex(
      game => game.get('game') === launchGameFromUrl
    );
    if (gameIndex === -1) {
      console.warn('GAME NOT FOUND:', launchGameFromUrl);
      store.dispatch(setLaunchError(launchGameFromUrl));
      return;
    }

    let gameToLaunch = gameList.get(gameIndex);

    console.log('game list:', gameList);
    console.log('game to launch: ', launchGameFromUrl, gameIndex, gameToLaunch);
    console.log(
      'will launch:',
      generateLink(
        gameToLaunch,
        store.getState().environment_information.get('launchOptions')
      )
    );

    redirectTo(
      generateLink(
        gameToLaunch,
        store.getState().environment_information.get('launchOptions')
      ) + additionalUrlParams
    );
  }
});
//store.dispatch(fetchOgaInformation())

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

unregister();



// WEBPACK FOOTER //
// ./src/index.js